import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetMindMap({ courseId, chapterId, configs = {}, enabled } = {}) {
  const { privateFetch } = useContext(FetchContext);

  function getMindMap() {
    return privateFetch
      .get(`/v1/admin/course/${courseId}/chapter/${chapterId}/mind-map`, configs)
      .then((res) => res.data);
  }

  return useQuery(['chapter-mindmap', chapterId], getMindMap, {
    enabled: !!courseId && !!chapterId,
    keepPreviousData: true,
  });
}

export default useGetMindMap;
